import { render, staticRenderFns } from "./Pencil.vue?vue&type=template&id=aaf3d0ae&"
import script from "./Pencil.vue?vue&type=script&lang=js&"
export * from "./Pencil.vue?vue&type=script&lang=js&"
import style0 from "./Pencil.vue?vue&type=style&index=0&id=aaf3d0ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports